module.exports = __webpack_public_path__ + "img/visa.02b860ac.svg";